<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <b-row>
      <b-col v-if="showError" class="col-12 col-md-6 mb-3">
        <b-card>
          <p v-if="showError === 'save'" class="text-center">{{ $t('queen.form.error') }}</p>
          <p v-if="showError === 'not found'" class="text-center">{{ $t('queen.form.not_found') }}</p>
        </b-card>
      </b-col>
      <b-col v-if="!loaded && !showError" class="col-12 col-md-12 mb-3">
        <b-card>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner></b-spinner>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <template v-if="showError !== 'not found'">
      <b-form-group label-for="title">
        <b-form-input :placeholder="$t('queen.form.title.label')" id="title" v-model="form.title" type="text" required :state="$v.form.title.$dirty ? !$v.form.title.$error : null" @blur="$v.form.title.$touch"></b-form-input>
      </b-form-group>
      <div class="d-flex">
        <b-form-group class="flex-grow-1 mr-3" label-for="slipyear">
          <b-form-input :placeholder="$t('queen.form.slipyear.label')" id="slipyear" v-model="form.slipyear" type="number"></b-form-input>
        </b-form-group>
        <div class="w-25 text-center form-control" :style="{ background: crownColor }">{{ $t('queen.color') }}</div>
      </div>
      <b-form-group label-for="marked">
        <b-form-checkbox id="marked" v-model="form.marked">{{ $t('queen.form.marked.label') }}</b-form-checkbox>
      </b-form-group>
      <b-form-group label-for="parentage">
        <b-form-select id="parentage" :class="{ 'with-placeholder': !form.parentage }" v-model="form.parentage">
          <option :value="null" disabled>{{ $t('queen.form.parentage.label') }}</option>
          <option v-for="(text, value) in $t('queen.form.parentage.options')" :value="value" :key="value">{{ text }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label-for="mating">
        <b-form-select id="mating" :class="{ 'with-placeholder': !form.mating }" v-model="form.mating">
          <option :value="null" disabled>{{ $t('queen.form.mating.label') }}</option>
          <option v-for="(text, value) in $t('queen.form.mating.options')" :value="value" :key="value">{{ text }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label-for="matingDetail">
        <b-form-textarea id="matingDetail" v-model="form.matingDetail" :placeholder="$t('queen.form.matingDetail.label')"></b-form-textarea>
      </b-form-group>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent text-primary border-primary border form-control text-center" :title="$t('queen.form.cancel')" :to="'/colony/' + colony + '/' + apiary">
            {{ $t('queen.form.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6">
          <b-button class="d-block w-100" type="submit" variant="primary">{{ $t('queen.form.submit') }}</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 col-md-6 col-sm-12"></b-col>
        <b-col class="col-12 col-md-6 col-sm-12">
          <queen-delete :id="id" :colony="colony" :apiary="apiary"></queen-delete>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalQueenSave'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </template>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import config from '@/config'
import QueenDelete from './QueenDelete'

export default {
  name: 'QueenForm',
  components: { QueenDelete },
  props: ['id', 'colony', 'apiary'],
  data () {
    return {
      showError: false,
      loading: false,
      loaded: false,
      form: {
        title: null,
        slipyear: (new Date()).getFullYear(),
        marked: false,
        parentage: null,
        mating: null,
        matingDetail: null
      }
    }
  },
  computed: {
    crownColor () {
      return config.getCrownColor(this.form.slipyear)
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalQueenSave')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalQueenSave')
    },
    async submit () {
      if (navigator.onLine) {
        this.$v.form.$touch()
        if (!this.$v.$error) {
          this.loading = true
          let result
          try {
            const token = await this.$api.user.getToken()
            result = await this.$api.queens.save({
              id: this.id,
              colony: this.colony,
              title: this.form.title,
              slipyear: this.form.slipyear,
              marked: this.form.marked,
              parentage: this.form.parentage,
              mating: this.form.mating,
              matingDetail: this.form.matingDetail,
              token
            })
            this.loading = false

            if (!this.id) {
              this.$api.colonies.invalidate()
            }
          } catch (e) { // network error etc.
            if (e.response && e.response.status === 403) {
              this.loading = false
              this.$router.replace('/login')
            }

            result = false
          }

          this.showError = (!result ? 'save' : false)

          if (result) {
            this.$router.replace('/colony/' + this.colony + '/' + this.apiary)
          }
        }
      } else {
        this.showOffLineModal()
      }
    },
    async loadData () {
      if (this.id) {
        try {
          const data = await this.$api.queens.getOne(this.id)
          this.form.title = data.title || this.form.title
          this.form.slipyear = data.slipyear || this.form.slipyear
          this.form.marked = data.marked || this.form.marked
          this.form.parentage = data.parentage || this.form.parentage
          this.form.mating = data.mating || this.form.mating
          this.form.matingDetail = data.matingDetail || this.form.matingDetail
          if (data) {
            this.loaded = true
          } else {
            this.showError = 'not found'
          }
          return data
        } catch (e) {
          this.showError = 'not found'
        }
      } else {
        this.loaded = true
      }

      return null
    }
  },
  validations: {
    form: {
      title: {
        required
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
